import { ColumnMain } from "#/models/column-main";
import { Column } from "#/models/column";
import { Trans } from "@lingui/macro";
import { Tag } from "antd";
import React from "react";

const MscStockMovementModel = (): ColumnMain => {

    const columns : Array<Column> = new Array();
    
    columns.push({key:'id', width: 80, filter:true, sorter:true, title:<Trans>ID</Trans>});
    columns.push({key:'mscStock.item.itemNo', dataIndex: ['mscStock', 'item', 'itemNo'], width: 150, filter:true, sorter:true, title:<Trans>MSC Part Number</Trans>});
    columns.push({key:'mscStock.item.name', dataIndex: ['mscStock', 'item', 'name'], width: 250, filter:true, sorter:true, title:<Trans>Item Name</Trans>});
    columns.push({key:'mscStock.item.supplier.code', dataIndex: ['mscStock', 'item', 'supplier', 'code'], width: 150, filter:true, sorter:true, title:<Trans>Supplier Code</Trans>});
    columns.push({key:'quantity', width: 120, filter:true, sorter:true, title:<Trans>Quantity</Trans>});
    columns.push({
        key: 'movement',
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>PLUS</Trans>,
                value: 'PLUS',
            },
            {
                label: <Trans>MINUS</Trans>,
                value: 'MINUS',
            }
        ],
        sorter: true,
        width: 180,
        title: <Trans>Movement Type</Trans>,
        render: text => {
            let color = 'gray';
            let transText;
            if (text === 'PLUS') {
                color = 'green';
                transText = <Trans>PLUS</Trans>;
            } else if (text === 'MINUS') {
                color = 'red';
                transText = <Trans>MINUS</Trans>;
            }
            return (
                <Tag color={color} key={text}>
                    {transText}
                </Tag>
            );
        },
    });
    columns.push({key:'updatedDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 200, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 200, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return {
        columns: columns,
        url: "/resource/msc-stock-movements"
    };

}
export default MscStockMovementModel();
